import React, { FC, ReactNode, useContext, useEffect, useLayoutEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import { useTour } from '@reactour/tour';
import Button, { IButtonProps } from '../../../components/bootstrap/Button';
import { HeaderRight } from '../../../layout/Header/Header';
import OffCanvas, {
	OffCanvasBody,
	OffCanvasHeader,
	OffCanvasTitle,
} from '../../../components/bootstrap/OffCanvas';
import Alert from '../../../components/bootstrap/Alert';
import Dropdown, {
	DropdownItem,
	DropdownMenu,
	DropdownToggle,
} from '../../../components/bootstrap/Dropdown';
import Icon from '../../../components/icon/Icon';
import ThemeContext from '../../../contexts/themeContext';
import LANG, { getLangWithKey, ILang } from '../../../lang';
import showNotification from '../../../components/extras/showNotification';
import useDarkMode from '../../../hooks/useDarkMode';
import Popovers from '../../../components/bootstrap/Popovers';
import Spinner from '../../../components/bootstrap/Spinner';
import Avatar from '../../../components/Avatar';
import UserImage6 from '../../../assets/img/wanna/wanna6.png';
import UserImage6Webp from '../../../assets/img/wanna/wanna6.webp';

interface ICommonHeaderRightProps {
	beforeChildren?: ReactNode;
	afterChildren?: ReactNode;
}
const CommonHeaderRight: FC<ICommonHeaderRightProps> = ({ beforeChildren, afterChildren }) => {
	const { darkModeStatus, setDarkModeStatus } = useDarkMode();

	const styledBtn: IButtonProps = {
		color: darkModeStatus ? 'dark' : 'light',
		hoverShadow: 'default',
		isLight: !darkModeStatus,
		size: 'lg',
	};

	const { i18n } = useTranslation();
	const [userData, setUserData] = useState({
		id: '',
		first_name: '',
		last_name: '',
		designation: {
			name: '',
		},
		branch: {
			name: '',
		},
		company: {
			name: '',
		},
		division: {
			name: '',
		},
	});

	useEffect(() => {
		if (localStorage.getItem('userData') != '' && localStorage.getItem('userData') != null) {
			setUserData(JSON.parse(localStorage.getItem('userData') || ''));
		}
	}, []);

	const changeLanguage = (lng: ILang['key']['lng']) => {
		i18n.changeLanguage(lng).then();
		showNotification(
			<span className='d-flex align-items-center'>
				<Icon icon={getLangWithKey(lng)?.icon} size='lg' className='me-1' />
				<span>{`Language changed to ${getLangWithKey(lng)?.text}`}</span>
			</span>,
			'You updated the language of the site. (Only "Aside" was prepared as an example.)',
		);
	};

	useLayoutEffect(() => {
		document.documentElement.setAttribute('lang', i18n.language.substring(0, 2));
	});

	const { setIsOpen } = useTour();

	return (
		<HeaderRight>
			<div className='row g-3'>
				{beforeChildren}
				{localStorage.getItem('tourModalStarted') === 'shown' && (
					<div className='col-auto position-relative'>
						{/* <Popovers trigger='hover' desc='Start the "Facit" tour'>
							<Button
								{...styledBtn}
								icon='Tour'
								onClick={() => setIsOpen(true)}
								aria-label='Start the "Facit" tour'
							/>
						</Popovers>
						<Icon
							icon='Circle'
							className={classNames(
								'position-absolute start-65',
								'text-danger',
								'animate__animated animate__heartBeat animate__infinite animate__slower',
							)}
						/> */}
					</div>
				)}
			</div>

			<div className='col d-flex align-items-center text-end'>
				{/* <div className='row g-0 pt-1 mt-1 mb-1 pb-1 w-100' style={{ maxWidth: '900' }}>
					<div className='col w-100 align-items-start me-5' style={{ maxWidth: '90' }}>
						<div className='d-flex justify-content-between align-items-start'>
							<div className='d-flex align-items-start me-3'>
								<div className='fw-bold fs-6'>Branch:</div>
								<div
									className='text-muted ms-2'
									style={{ maxWidth: '90', whiteSpace: 'nowrap' }}>
									{`${userData.branch.name}`}
								</div>
							</div>
						</div>
						<div
							className='d-flex justify-content-between align-items-start'
							style={{ maxWidth: '90' }}>
							<div
								className='d-flex align-items-start me-3'
								style={{ maxWidth: '90' }}>
								<div className='fw-bold fs-6'>Company:</div>
								<div
									className='text-muted ms-2'
									style={{ maxWidth: '90', whiteSpace: 'nowrap' }}>
									{`${userData.company.name}`}
								</div>
							</div>
						</div>
					</div>

					<div className='col w-100 align-items-start ' style={{ maxWidth: '90' }}>
						<div className='d-flex justify-content-between align-items-start'>
							<div className='d-flex align-items-start me-3'>
								<div className='fw-bold fs-6'>Division:</div>
								<div
									className='text-muted ms-2'
									style={{ maxWidth: '90', whiteSpace: 'nowrap' }}>
									{`${userData.division.name}`}
								</div>
							</div>
						</div>
						<div
							className='d-flex justify-content-between align-items-start'
							style={{ maxWidth: '900' }}>
							<div className='d-flex align-items-start me-3'>
								<div className='fw-bold fs-6'>Designation:</div>
								<div
									className='text-muted ms-2'
									style={{ maxWidth: '90', whiteSpace: 'nowrap' }}>
									{`${userData.designation.name}`}
								</div>
							</div>
						</div>
					</div>
				</div> */}

				{/* <div className='me-3'>
					<div className='text-end'>
						<div className='fw-bold fs-6 mb-0' style={{ whiteSpace: 'nowrap' }}>
							{`${userData.first_name + ' ' + userData.last_name}`}
						</div>
						<div className='text-muted'>
							<small>{`${userData.designation.name}`}</small>
						</div>
					</div>
				</div>

				<div className='position-relative'>
					<Avatar srcSet={UserImage6Webp} src={UserImage6} size={48} color={'success'} />
				</div> */}
			</div>
		</HeaderRight>
	);
};
CommonHeaderRight.propTypes = {
	beforeChildren: PropTypes.node,
	afterChildren: PropTypes.node,
};
CommonHeaderRight.defaultProps = {
	beforeChildren: null,
	afterChildren: null,
};

export default CommonHeaderRight;
